import type { AuthSession } from 'src/auth/store/firebase/auth-session';

export type PointPayIdentity = { uid: string; userId: string; businessId: string };

export class PointPayIdentityError extends Error {
  readonly isAuthError = true;
}

export function resolvePointPayIdentity(session: AuthSession): PointPayIdentity {
  const { uid, claims } = session;
  const userId = uid.startsWith('user:') ? uid.slice(5) : '';
  if (
    !userId ||
    claims.accountType !== 'USER' ||
    claims.userId !== userId ||
    typeof claims.businessId !== 'string' ||
    !claims.businessId
  ) {
    throw new PointPayIdentityError('Sign in with your own user account to access PointPay.');
  }
  return { uid, userId, businessId: claims.businessId };
}

export function pointPayReturnPath(value: string | null): string {
  if (
    !value ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    value.includes('\\') ||
    Array.from(value).some((character) => character.charCodeAt(0) < 32)
  )
    return '/online-payment';
  try {
    const url = new URL(value, 'https://pointpay.invalid');
    if (
      url.origin !== 'https://pointpay.invalid' ||
      !(url.pathname === '/online-payment' || url.pathname.startsWith('/online-payment/'))
    )
      return '/online-payment';
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return '/online-payment';
  }
}
